(() => {
  const post = (url, body) =>
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(async (r) => {
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
      return j;
    });
  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const SECTIONS = 'cart-drawer,cart-icon-bubble';

  // Keeps free gifts in step with the number of devices in the cart.
  async function reconcile() {
    const cart = await getCart();
    let o;
    try { o = JSON.parse(cart.attributes._sv_offer || ''); } catch (e) { return; }
    if (!o) return;
    const count = (id) => cart.items.filter((i) => i.variant_id === id).reduce((n, i) => n + i.quantity, 0);
    const devices = cart.items.filter((i) => i.product_id === o.p).reduce((n, i) => n + i.quantity, 0);
    const rule = devices ? o.r[Math.min(devices, o.r.length) - 1] : [0, 0];
    const updates = {};
    if (o.b && count(o.b) !== rule[0]) updates[o.b] = rule[0];
    if (o.m && count(o.m) !== rule[1]) updates[o.m] = rule[1];
    if (!Object.keys(updates).length) return;
    const res = await post('/cart/update.js', { updates, sections: SECTIONS, sections_url: location.pathname });
    const drawer = document.querySelector('cart-drawer');
    if (res.item_count === 0 || !drawer || location.pathname.endsWith('/cart')) return location.reload();
    drawer.renderContents(res);
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => reconcile().catch(() => {}));
    }
  });

  // Delivery estimate from the shipping policy: 1-3 business days to process, then 5-12 business days in transit.
  const addBusinessDays = (date, n) => { const d = new Date(date); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
  const shortDate = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  document.querySelectorAll('[data-sv-eta-line]').forEach((line) => {
    const now = new Date();
    line.querySelector('[data-sv-eta]').textContent = shortDate(addBusinessDays(now, 6)) + ' to ' + shortDate(addBusinessDays(now, 15));
    line.hidden = false;
  });
  // Countdown to a real end date set in the theme editor. Hidden when no date is set or the date has passed.
  document.querySelectorAll('[data-sv-end]').forEach((line) => {
    const end = new Date(line.dataset.svEnd + 'T23:59:59');
    const tick = () => {
      const ms = end - new Date();
      if (!(ms > 0)) { line.hidden = true; return false; }
      const m = Math.floor(ms / 60000);
      line.querySelector('[data-sv-countdown]').textContent = Math.floor(m / 1440) + 'd ' + Math.floor((m % 1440) / 60) + 'h ' + (m % 60) + 'm';
      line.hidden = false;
      return true;
    };
    if (tick()) setInterval(tick, 30000);
  });

  // Problem tabs (also used on the homepage)
  document.querySelectorAll('[data-sv-tabs]').forEach((box) => {
    const tabs = [...box.querySelectorAll('[role=tab]')];
    const panels = [...box.querySelectorAll('[role=tabpanel]')];
    tabs.forEach((t, i) => t.addEventListener('click', () => {
      tabs.forEach((x, n) => x.setAttribute('aria-selected', n === i));
      panels.forEach((p, n) => { p.hidden = n !== i; });
    }));
  });

  const cfgEl = document.getElementById('sv-offer-config');
  if (!cfgEl) return;
  const cfg = JSON.parse(cfgEl.textContent);
  const money = (c) => new Intl.NumberFormat('en-US', { style: 'currency', currency: cfg.currency }).format(c / 100);
  const firstAvail = (cfg.variants.find((v) => v.available) || cfg.variants[0]).id;
  const state = { qty: cfg.defaultQty, colors: [], mix: false };
  const fit = () => { while (state.colors.length < state.qty) state.colors.push(state.colors[0] || firstAvail); state.colors.length = state.qty; };
  fit();
  const variant = (id) => cfg.variants.find((v) => v.id === id);
  const tier = () => cfg.tiers.find((t) => t.qty === state.qty);
  const rules = cfg.tiers.map((t) => [t.book ? 1 : 0, t.mask ? 1 : 0]);
  const total = () => state.colors.map((id) => variant(id).price).sort((x, y) => y - x).slice(0, state.qty - tier().free).reduce((n, p) => n + p, 0);
  const allAvailable = () => state.colors.every((id) => variant(id).available);
  const notify = () => document.dispatchEvent(new CustomEvent('sv:change'));

  async function addToCart(btn, errEl) {
    const label = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    if (errEl) errEl.textContent = '';
    try {
      const cart = await getCart();
      const existing = cart.items.filter((i) => i.product_id === cfg.productId).reduce((n, i) => n + i.quantity, 0);
      const grouped = {};
      state.colors.forEach((id) => { grouped[id] = (grouped[id] || 0) + 1; });
      const items = Object.keys(grouped).map((id) => ({ id: Number(id), quantity: grouped[id] }));
      await post('/cart/add.js', { items });
      const rule = rules[Math.min(existing + state.qty, rules.length) - 1];
      const updates = {};
      if (cfg.gifts.book) updates[cfg.gifts.book] = rule[0];
      if (cfg.gifts.mask) updates[cfg.gifts.mask] = rule[1];
      const res = await post('/cart/update.js', { updates, attributes: { _sv_offer: JSON.stringify({ p: cfg.productId, m: cfg.gifts.mask, b: cfg.gifts.book, r: rules }) }, sections: SECTIONS, sections_url: location.pathname });
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) { location.href = '/cart'; return; }
      drawer.classList.remove('is-empty');
      drawer.renderContents(res);
    } catch (e) {
      if (errEl) errEl.textContent = e.message;
    }
    btn.innerHTML = label;
    btn.removeAttribute('aria-busy');
    btn.disabled = !allAvailable();
    notify();
  }

  class SvOffer extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.key || 'hero';
      const core = this.querySelector('[data-sv-core]');
      if (this.key !== 'hero') {
        const src = document.querySelector('sv-offer[data-key=hero] [data-sv-core]');
        if (src) core.innerHTML = src.innerHTML.replaceAll('sv-tier-hero', 'sv-tier-' + this.key);
      }
      this.addEventListener('change', (e) => {
        const t = e.target;
        if (t.dataset.svQty) { state.qty = Number(t.value); fit(); if (state.qty === 1) state.mix = false; notify(); }
        if (t.dataset.svSlot) {
          const i = Number(t.dataset.svSlot);
          if (state.mix) state.colors[i] = Number(t.value);
          else state.colors = state.colors.map(() => Number(t.value));
          if (i === 0) document.dispatchEvent(new CustomEvent('sv:media', { detail: variant(state.colors[0]).media }));
          notify();
        }
      });
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-sv-add]');
        if (b) { e.preventDefault(); addToCart(b, this.querySelector('[data-sv-error]')); }
        if (e.target.closest('[data-sv-mix]')) { state.mix = true; notify(); }
      });
      document.addEventListener('sv:change', () => this.render());
      this.render();
    }
    colorRows() {
      const box = this.querySelector('[data-sv-colors]');
      if (!box) return;
      if (cfg.variants.length < 2) { box.hidden = true; return; }
      const rows = state.mix ? state.qty : 1;
      const sig = this.key + rows + state.qty;
      if (box.dataset.sig !== sig) {
        box.dataset.sig = sig;
        let html = '';
        for (let i = 0; i < rows; i++) {
          html += '<fieldset class="sv-color-row"><legend>' + (rows === 1 ? 'Color' : 'Device ' + (i + 1)) + '</legend>' + cfg.variants.map((v) =>
            '<label class="sv-pill"><input type="radio" name="sv-color-' + this.key + '-' + i + '" value="' + v.id + '" data-sv-slot="' + i + '"' + (v.available ? '' : ' disabled') + '><span><i class="' + (/white/i.test(v.title) ? 'is-white' : '') + '"></i>' + v.title + '</span></label>').join('') + '</fieldset>';
        }
        if (state.qty > 1 && !state.mix) html += '<button type="button" class="sv-mix" data-sv-mix>Want different colors?</button>';
        box.innerHTML = html;
      }
      box.querySelectorAll('input').forEach((inp) => { inp.checked = state.colors[Number(inp.dataset.svSlot)] === Number(inp.value); });
    }
    render() {
      this.querySelectorAll('[data-sv-qty]').forEach((r) => {
        r.checked = Number(r.value) === state.qty;
        r.closest('.sv-tier').classList.toggle('is-active', r.checked);
      });
      this.colorRows();
      this.querySelectorAll('[data-sv-total]').forEach((n) => { n.textContent = money(total()); });
      const b = this.querySelector('[data-sv-add]');
      if (b && b.getAttribute('aria-busy') !== 'true') b.disabled = !allAvailable();
    }
  }
  customElements.define('sv-offer', SvOffer);

  // Sticky bar: shown once the hero button has scrolled away, hidden while another buy button or the footer is on screen
  const sticky = document.querySelector('[data-sv-sticky]');
  if (sticky) {
    const paint = () => {
      sticky.querySelector('[data-sv-sticky-total]').textContent = money(total());
      sticky.querySelector('button').disabled = !allAvailable();
    };
    document.addEventListener('sv:change', paint);
    paint();
    sticky.querySelector('button').addEventListener('click', (e) => addToCart(e.currentTarget));
    const visible = new Set();
    const hero = document.querySelector('.sv-hero .sv-atc');
    const update = () => {
      const past = hero && hero.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-visible', !!past && visible.size === 0);
    };
    const io = new IntersectionObserver((es) => {
      es.forEach((x) => (x.isIntersecting ? visible.add(x.target) : visible.delete(x.target)));
      update();
    });
    document.querySelectorAll('.sv-atc, .sv-foot, [data-sv-hide-sticky]').forEach((n) => io.observe(n));
    addEventListener('scroll', update, { passive: true });
  }

  // Gallery
  const gal = document.querySelector('[data-sv-gallery]');
  if (gal) {
    const track = gal.querySelector('[data-sv-track]');
    const slides = [...track.children];
    const thumbs = [...gal.querySelectorAll('[data-sv-thumb]')];
    let cur = 0;
    const go = (i) => track.scrollTo({ left: slides[(i + slides.length) % slides.length].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    const mark = (i) => {
      cur = i;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i));
      if (thumbs[i]) thumbs[i].parentElement.scrollTo({ left: thumbs[i].offsetLeft - thumbs[i].parentElement.offsetLeft - 80, behavior: 'smooth' });
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    gal.querySelector('[data-sv-prev]')?.addEventListener('click', () => go(cur - 1));
    gal.querySelector('[data-sv-next]')?.addEventListener('click', () => go(cur + 1));
    const sio = new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) mark(slides.indexOf(x.target)); }), { root: track, threshold: 0.6 });
    slides.forEach((s) => sio.observe(s));
    document.addEventListener('sv:media', (e) => {
      const i = slides.findIndex((s) => Number(s.dataset.mediaId) === e.detail);
      if (i > -1) go(i);
    });
  }
})();
